import React, {createContext, useState} from "react";

const SearchContext = React.createContext({});

const SearchContextProvider = ({ children }) => {

  const [search, setSearch] = useState(false);

  return (
    <SearchContext.Provider value={{ search, setSearch }}>
      {children}
    </SearchContext.Provider>
  );
};


export { SearchContext, SearchContextProvider };